(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("locale/locale", [], factory);
	else if(typeof exports === 'object')
		exports["locale/locale"] = factory();
	else
		root["locale/locale"] = factory();
})(window, function() {
return 